import { defBaseUnit } from '../registry';

export const transportUnits = [
  defBaseUnit('tonne-kilometer', 'tonne-kilometer'),
];
